// Firestore collection and subcollection names — single source of truth.
// Python scripts mirror these manually in models/collections.py.

export const USERS_COL = "users"
export const CONNECTORS_COL = "connectors"
export const APPS_COL = "apps"

// Subcollections under /users/{uid}
export const CONNECTIONS_SUBCOL = "connections"
export const CONNECTION_SECRETS_SUBCOL = "connection_secrets"
export const USER_APPS_SUBCOL = "apps"

// Subcollections under /users/{uid}/connections/{connectionId}
export const ACCOUNTS_SUBCOL = "accounts"

// Subcollections under /users/{uid}/connections/{connectionId}/accounts/{accountId}
export const TRANSACTIONS_SUBCOL = "transactions"
